export const BASE_URL = process.env.REACT_APP_API_URL;
export const BASE_URL_PROD = process.env.REACT_APP_API_URL_PROD;
export const AZURE_API_URL = process.env.REACT_APP_API_AZURE;
export const AUTH_URL = process.env.REACT_APP_AUTH_URL;
export const GESDOC_URL = process.env.REACT_APP_API_GESDOC_URL;
export const AZURE_API_URL_DEV = process.env.REACT_APP_API_AZURE_DEV;
